import React, { useEffect, useState } from "react";
import { getSettings } from "../services/Settings";
import InfoBox from "../components/system/InfoBox";
import ContainerTitle from "../components/system/ContainerTitle";
import { serviceActions, useServiceReducer } from "../reducers/serviceReducer";

import InputWorkerCard from "../components/configuration/InputWorkerCard";

export default function Configuration() {
  const [settings, setSettings] = useState({});
  const [serviceState, serviceDispatch] = useServiceReducer();

  useEffect(() => {
    load();
  }, []);

  async function load() {
    serviceDispatch({ type: serviceActions.LOADING });
    try {
      const result = await getSettings();
      setSettings(result.val);
      serviceDispatch({ type: serviceActions.SUCCESS });
    } catch (err) {
      console.log("error", err);
      serviceDispatch({ type: serviceActions.ERROR, payload: err.message });
    }
  }

  function displayInputWorkers() {
    if (!serviceState.loading && settings && settings.input_workers) {
      return settings.input_workers.map((iw) => {
        return (
          <div key={`iwc_${iw.name}`} className="col-xl-6 col-md-6">
            <InputWorkerCard worker={iw} />
          </div>
        );
      });
    } else {
      return (
        <div key="kwibwd" className="col-12">
          <InfoBox
            keyv="kwibw"
            type="warning"
            message="No input  workers defined  in  the  system"
          />
        </div>
      );
    }
  }
  return (
    <React.Fragment>
      <ContainerTitle title="Configuration" loading={serviceState.loading} />
      <h2>Input Workers</h2>
      <div className="row">{displayInputWorkers()}</div>
    </React.Fragment>
  );
}
